export const useCategoryAncestorsDiscipline = (
  pAncestors: CategorySchema[] | Ref<CategorySchema[]>
): CategorySchema => {
  const ancestors = toValue(pAncestors);

  // const category = ancestors[ancestors.length - 1];

  const discipline = computed(() => {
    // if (
    //   category.contentType === ContentTypes.CourseAndQuiz ||
    //   category.contentType === ContentTypes.Training ||
    //   category.contentType === ContentTypes.Discipline
    // ) {
    //   return category;
    // }
    const categoryDiscipline = ancestors.find(
      (link) =>
        link.contentType === ContentTypes.Discipline ||
        link.contentType === ContentTypes.Training ||
        link.contentType === ContentTypes.CourseAndQuiz
    );
    if (categoryDiscipline) return categoryDiscipline;
    return null;
  });

  return discipline.value;
};
